<script lang="ts">
    export let url = ""
    import { isLoading } from "svelte-i18n"
    let AppComponent: typeof import("./AppContent.svelte").default | null = null
    $: if (!$isLoading) {
        console.log("AppContent loaded")
        import("./AppContent.svelte").then((module) => {
            AppComponent = module.default
        })
    }
</script>

{#if !!AppComponent}
    <svelte:component this="{AppComponent}" {url} />
{:else}
    ...loading
{/if}
